export const COMPANY_NAME = "NYASOSO ONLINE"
export const COMPANY_NAME_FULL = "NYASOSO ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "NYASOSO ONLINE"
export const META_DESCRIPTION = "Welcome to NYASOSO ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.nyacucoop.com"
export const ENABLE_OTHER_DEPOSIT = false
